/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PointsAmount } from './PointsAmount';
import {
    PointsAmountFromJSON,
    PointsAmountFromJSONTyped,
    PointsAmountToJSON,
    PointsAmountToJSONTyped,
} from './PointsAmount';
import type { CurrencyAmount } from './CurrencyAmount';
import {
    CurrencyAmountFromJSON,
    CurrencyAmountFromJSONTyped,
    CurrencyAmountToJSON,
    CurrencyAmountToJSONTyped,
} from './CurrencyAmount';

/**
 * A multi-night rate for a hotel
 * @export
 * @interface MultiNightRate
 */
export interface MultiNightRate {
    /**
     * 
     * @type {number}
     * @memberof MultiNightRate
     */
    vervotechPropertyId?: number;
    /**
     * 
     * @type {string}
     * @memberof MultiNightRate
     */
    checkin: string;
    /**
     * 
     * @type {string}
     * @memberof MultiNightRate
     */
    checkout: string;
    /**
     * 
     * @type {CurrencyAmount}
     * @memberof MultiNightRate
     */
    cashCost?: CurrencyAmount;
    /**
     * 
     * @type {CurrencyAmount}
     * @memberof MultiNightRate
     */
    nightlyCashCost?: CurrencyAmount;
    /**
     * 
     * @type {PointsAmount}
     * @memberof MultiNightRate
     */
    pointsCost?: PointsAmount;
    /**
     * 
     * @type {PointsAmount}
     * @memberof MultiNightRate
     */
    nightlyPointsCost?: PointsAmount;
    /**
     * Point redemption value in cents/pt
     * @type {number}
     * @memberof MultiNightRate
     */
    pointRedemptionValue?: number;
    /**
     * 
     * @type {number}
     * @memberof MultiNightRate
     */
    cashPercentile?: number;
    /**
     * 
     * @type {number}
     * @memberof MultiNightRate
     */
    redemptionRatePercentile?: number;
    /**
     * 
     * @type {boolean}
     * @memberof MultiNightRate
     */
    available: boolean;
    /**
     * 
     * @type {string}
     * @memberof MultiNightRate
     */
    updatedAt: string;
}

/**
 * Check if a given object implements the MultiNightRate interface.
 */
export function instanceOfMultiNightRate(value: object): value is MultiNightRate {
    if (!('checkin' in value) || value['checkin'] === undefined) return false;
    if (!('checkout' in value) || value['checkout'] === undefined) return false;
    if (!('available' in value) || value['available'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function MultiNightRateFromJSON(json: any): MultiNightRate {
    return MultiNightRateFromJSONTyped(json, false);
}

export function MultiNightRateFromJSONTyped(json: any, ignoreDiscriminator: boolean): MultiNightRate {
    if (json == null) {
        return json;
    }
    return {
        
        'vervotechPropertyId': json['vervotech_property_id'] == null ? undefined : json['vervotech_property_id'],
        'checkin': json['checkin'],
        'checkout': json['checkout'],
        'cashCost': json['cash_cost'] == null ? undefined : CurrencyAmountFromJSON(json['cash_cost']),
        'nightlyCashCost': json['nightly_cash_cost'] == null ? undefined : CurrencyAmountFromJSON(json['nightly_cash_cost']),
        'pointsCost': json['points_cost'] == null ? undefined : PointsAmountFromJSON(json['points_cost']),
        'nightlyPointsCost': json['nightly_points_cost'] == null ? undefined : PointsAmountFromJSON(json['nightly_points_cost']),
        'pointRedemptionValue': json['point_redemption_value'] == null ? undefined : json['point_redemption_value'],
        'cashPercentile': json['cash_percentile'] == null ? undefined : json['cash_percentile'],
        'redemptionRatePercentile': json['redemption_rate_percentile'] == null ? undefined : json['redemption_rate_percentile'],
        'available': json['available'],
        'updatedAt': json['updated_at'],
    };
}

export function MultiNightRateToJSON(json: any): MultiNightRate {
    return MultiNightRateToJSONTyped(json, false);
}

export function MultiNightRateToJSONTyped(value?: MultiNightRate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'vervotech_property_id': value['vervotechPropertyId'],
        'checkin': value['checkin'],
        'checkout': value['checkout'],
        'cash_cost': CurrencyAmountToJSON(value['cashCost']),
        'nightly_cash_cost': CurrencyAmountToJSON(value['nightlyCashCost']),
        'points_cost': PointsAmountToJSON(value['pointsCost']),
        'nightly_points_cost': PointsAmountToJSON(value['nightlyPointsCost']),
        'point_redemption_value': value['pointRedemptionValue'],
        'cash_percentile': value['cashPercentile'],
        'redemption_rate_percentile': value['redemptionRatePercentile'],
        'available': value['available'],
        'updated_at': value['updatedAt'],
    };
}

